<style lang="stylus" scoped>
@import './cardMap.stylus';

.listFather {
  position: relative;

  .ul {
    position: absolute;
    bottom: 0;
    left: 0;
    border: 1px solid #ced3de;
  }
}

li {
  list-style: none;
  height: 36px;
  line-height: 36px;
  padding-left: 15px;
  cursor: pointer;

  &:hover {
    background: #f2f2f2;
  }
}
</style>
<template>
  <div class="home-main">
    <div class="map-search radius-5 b1 p-2" style="height:550px;">
      <el-row :gutter="20">
        <el-col>
          <div class="demo-input-suffix">
            <span class="color1 font14">网点编码</span>
            <el-input
              style="margin-top:10px"
              placeholder="请输入内容"
              v-model.number.trim="siteCode"
              clearable
            ></el-input>
          </div>
        </el-col>
        <el-col>
          <div class="demo-input-suffix">
            <span class="color1 font14">网点名称</span>
            <el-input
              class="listFather"
              style="margin-top:10px"
              placeholder="请输入网点名称"
              clearable
              :span="8"
              v-model.trim="siteName"
            ></el-input>
            <div
              class="ul"
              v-if="searchBlock"
              style="border:1px solid #ced3de;position:absolute;z-index:2;width:100%;background:#fff;width:500px;border-top-color:transparent;"
            >
              <li
                v-for="(item, index) in list"
                :key="index"
                @click="editSearch(item)"
              >{{item.siteName}}</li>
            </div>
          </div>
        </el-col>
        <el-col>
          <div class="demo-input-suffix">
            <el-date-picker
              :clearable="false"
              v-model="timeSection"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-col>
        <el-col>
          <div class="demo-input-suffix">
            <el-button type="success" style="background:#00a28a;" @click="search">查询</el-button>
            <el-button class="m-l-2" @click="goBack">返回上级</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import http from '@/api/cardData'
import Cookies from 'js-cookie'
export default {
  name: 'home',
  components: {},
  data() {
    return {
      timeSection: [
        new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 0 * 24 * 3600 * 1000) * 1
      ],
      siteCode: null,
      siteName: null,
      siteCode1: null,
      list: [],
      searchBlock: false //搜索框是否显示
    }
  },
  computed: {
    userType() {
      return this.$store.getters.userType != 2
    },
    allTab() {
      return this.$store.state.app.tab
    }
  },
  watch: {
    siteName: function(value, oldValue) {
      // let that = this
      // if (value.length >= 2) {
      //   that.searchBlock = true
      //   let _option = {
      //     siteName: value,
      //     phone: Cookies.get('user')
      //   }
      //   http[that.allTab].searchSiteDate(_option).then(e => {
      //     that.list = e.data.clist
      //   })
      // } else {
      //   that.searchBlock = false
      // }

      let that = this
      that.searchBlock = false
      if (value.length >= 1){
        let _option = {
          siteName: value,
          phone: Cookies.get('user')
        }
        http[that.allTab].searchSiteDate(_option).then(e => {
          that.list = e.data.clist||[]
          if(that.list.length>1){
              that.searchBlock = true
          }
        })
      }else{
        that.list = []
      }
    },
 
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    init() {},
    searchEvent(it) {
      this.searchItem.forEach(e => {
        e.selected = false
      })
      it.selected = true
    },
    search() {
      let that = this
      let _option = {
        timeSection: that.timeSection
      }
      if (!this.siteCode && !this.siteName) {
        this.$notify.error({
          title: '错误',
          message: '网点名称和网点编码不能同时为空'
        })
        return
      }
      if (this.siteCode && (this.siteCode + '').length != 8) {
        this.$notify.error({
          title: '错误',
          message: '请输入正确的网点编码'
        })
        return
      }
      if (!this.siteCode&&this.list.length==0) {
        this.$notify.error({
          title: '错误',
          message: '请输入正确的网点名称'
        })
        return
      }
      if (this.siteCode && this.siteCode1) {
        if (this.siteCode != this.siteCode1) {
          this.$notify.error({
            title: '错误',
            message: '网点名称与网点编码不一致，请重新输入'
          })
          return
        }
      }
      
      if (this.siteCode || this.siteCode1) {
        _option.siteCode = this.siteCode || this.siteCode1
        this.$router.push({
          name: 'siteResult',
          query: {
            timeSection: JSON.stringify(_option.timeSection),
            siteCode: _option.siteCode,
            siteName:this.siteName
          }
        })
      }
    },
    editSearch(item) {
      this.siteName = item.siteName
      this.searchBlock = false
      this.siteCode1 = item.siteCode
    }
  },
  mounted() {
    this.init()
  }
}
</script>
